import React, { useEffect, useState } from "react";
import { StatCard } from "../home/SubComponent";
import { AppDispatch, RootState } from "redux/store";
import { useSelector, useDispatch } from "react-redux";
import Typography from "style-guide/component/Typography";
import { getDashboardStats } from "../../../redux/slice/rfpModuleSlice/dashboard";
import Loading from "style-guide/component/Loader";
import CreateProject from "../home/CreateProjectButton";
import PieChartsSection from "./PieChartsSection";
import { Dropdown } from "./Dropdown";
import { getUserProfile } from "../../../redux/slice/rfpModuleSlice/application";
import { useLocation } from "react-router-dom";

const options = [
  { label: "7 days", value: "7" },
  { label: "30 days", value: "30" },
  { label: "3 months", value: "90" },
];

const HomePage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { pathname } = useLocation();
  const [selected, setSelected] = useState("30");
  const { dashboardStats } = useSelector(
    (state: RootState) => state.dashboardData
  );
  const { userProfile, isLoading } = useSelector(
    (state: RootState) => state.applicationData
  );

  useEffect(() => {
    dispatch(getDashboardStats(selected));
    if (!pathname?.includes("dashboard")) {
      dispatch(getUserProfile());
    }
  }, [selected, pathname, dispatch]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="p-6 space-y-6 bg-white">
      {!pathname.includes("dashboard") && (
        <div className="flex justify-between ">
          <Typography
            variant="Heading 2"
            className="capitalize"
            text={`Welcome, ${userProfile?.userDetails[0]?.firstName}!`}
          />
          <div className="flex gap-14">
            <img
              src={userProfile?.userDetails[0]?.companyLogo}
              alt="companyLogo"
              className="w-fit h-10 object-cover"
              loading="lazy"
            />
            <CreateProject />
          </div>
        </div>
      )}
      <div className="flex justify-end p-2">
        <Dropdown
          options={options}
          value={selected}
          onChange={(val) => setSelected(val)}
        />
      </div>
      <div className="grid grid-cols-4 gap-5">
        <StatCard
          label="Open Projects"
          value={dashboardStats.projectCount?.active || 0}
          sections={[
            {
              label: "Create",
              value: dashboardStats.projectCount?.rfpGenerated?.active || 0,
            },
            {
              label: "Analyze",
              value: dashboardStats.projectCount?.analysis?.active || 0,
            },
            {
              label: "Negotiate",
              value: dashboardStats.projectCount?.negotiate?.active || 0,
            },
          ]}
        />
        <StatCard
          label="Completed Projects"
          value={dashboardStats.projectCount?.completed || 0}
          sections={[
            {
              label: "Create",
              value: dashboardStats.projectCount?.rfpGenerated?.completed || 0,
            },
            {
              label: "Analyze",
              value: dashboardStats.projectCount?.analysis?.completed || 0,
            },
            {
              label: "Negotiate",
              value: dashboardStats.projectCount?.negotiate?.completed || 0,
            },
          ]}
        />
        <StatCard
          label="Key Requirements"
          sections={[
            {
              label: "Created",
              value: dashboardStats.questionCounts?.rfpGenerated || 0,
            },
            {
              label: "Analyzed",
              value: dashboardStats.questionCounts?.analysis || 0,
            },
            {
              label: "Negotiated",
              value: dashboardStats.questionCounts?.negotiate || 0,
            },
          ]}
        />
      </div>

      {/* Pie Charts Section */}
      <div className="pt-10">
        <PieChartsSection dashboardStats={dashboardStats} />
      </div>
    </div>
  );
};

export default HomePage;
